import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck, faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import { isPresent } from '@shared/utils/isPresent';
import { filter } from 'rxjs/operators';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { MobileFormControl } from './mobile-form-control';

@Component({
  standalone: false,
  selector: 'app-mobile-form-control',
  templateUrl: './mobile-form-control.component.html',
  styleUrls: ['./mobile-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MobileFormControlComponent),
      multi: true
    }
  ]
})
export class MobileFormControlComponent
  extends AbstractFormControlComponent<MobileFormControl>
  implements OnInit, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() hidePhoneAvailable: boolean;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  faClose: any = faTimes;
  faEye: any = faEye;
  faEyeSlash: any = faEyeSlash;

  showPhone: boolean = true;
  matPrefix: string = '+33';
  originValue: string;
  phoneNumber: string;

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    this.control.valueChanges.pipe(filter(isPresent)).subscribe(value => {
      if (!this.originValue) {
        this.originValue = value;
        this.phoneNumber = value;

        if (this.hidePhoneAvailable === true) {
          this.hideShowPhoneToogle();
        }
      }
    });
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value?.indexOf('*') === -1 ? this.control.value : this.originValue);
  }

  hideShowPhoneToogle() {
    this.showPhone = !this.showPhone;
    this.matPrefix = this.showPhone ? '+33' : '***';
    if (this.showPhone === false) {
      const newValue = this.originValue.replace(/\d(?=\d{4})/g, '*');
      this.control.patchValue(newValue);
    } else {
      this.control.patchValue(this.originValue);
    }
  }

  public get hideErrorMark(): boolean {
    return this.control.hideErrorMark || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }
}
